import React, { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Relacionar, relacionInicial, relacionPayload, useNombreRelacion } from "@/components/asuntos/RecordatorioPuntual";

// Cambia solo la asociación del pago o recordatorio periódico, sin pasar por el asistente.
export const CambiarRelacion = ({ g }) => {
  const nombreRel = useNombreRelacion();
  const actual = relacionInicial(g);
  const [abierto, setAbierto] = useState(false);
  const [rel, setRel] = useState(actual);
  const [busy, setBusy] = useState(false);
  const guardar = async () => {
    setBusy(true);
    try {
      await api.patch(`/gestiones/${g.id}/asociacion`, relacionPayload(rel));
      toast.success(rel ? `Relacionado con ${nombreRel(rel)}` : "Ahora está sin asignar");
      setAbierto(false);
      window.dispatchEvent(new Event("aldia-gestiones"));
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo cambiar."); }
    finally { setBusy(false); }
  };
  return (
    <div className="py-3 space-y-2" data-testid="rp-detalle-relacion">
      <p className="text-sm font-semibold text-[#6E7A74]">Relacionado con</p>
      <div className="flex items-center gap-3">
        <p className="flex-1 text-lg text-[#1C2421]" data-testid="rp-detalle-relacion-valor">{nombreRel(actual)}</p>
        {!abierto && <button data-testid="rp-relacion-cambiar" onClick={() => { setRel(actual); setAbierto(true); }} className="min-h-[44px] px-4 rounded-xl border border-[#D6CFC2] bg-white font-semibold text-base text-[#3A6B56] inline-flex items-center gap-2"><Icons.Link2 size={18} /> Cambiar</button>}
      </div>
      {abierto && (
        <div className="space-y-2" data-testid="rp-relacion-form">
          <Relacionar value={rel} onChange={setRel} testid="rp-relacion-select" />
          <div className="flex gap-2">
            <button data-testid="rp-relacion-cancelar" onClick={() => setAbierto(false)} className="flex-1 min-h-[48px] rounded-xl bg-[#F2EDE4] border border-[#E5DFD5] font-semibold text-base text-[#1C2421]">Cancelar</button>
            <button data-testid="rp-relacion-guardar" disabled={busy || rel === actual} onClick={guardar} className="flex-1 min-h-[48px] rounded-xl bg-[#3A6B56] text-white font-semibold text-base disabled:opacity-50">{busy ? "Guardando…" : "Guardar"}</button>
          </div>
        </div>
      )}
    </div>
  );
};
